'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _group = require('../base/group');

var _group2 = _interopRequireDefault(_group);

var _util = require('../util');

var _addible = require('./addible');

var _addible2 = _interopRequireDefault(_addible);

var _campaign = require('./campaign');

var _campaign2 = _interopRequireDefault(_campaign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Group = function (_BaseGroup) {
  (0, _inherits3.default)(Group, _BaseGroup);

  function Group(data) {
    (0, _classCallCheck3.default)(this, Group);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Group.__proto__ || (0, _getPrototypeOf2.default)(Group)).call(this, data));

    _this.campaignPacks = [];
    return _this;
  }

  (0, _createClass3.default)(Group, [{
    key: 'getPreview',
    value: function getPreview(packs) {
      var ids = (0, _util.iposCleanPacks)(packs);
      console.log('refresh preview', ids.map(function (el) {
        return el.id;
      }));
      ids.map(function (item) {
        var _count = item.warehouseCount + item.storeCount;
        if (_count != item.count) {
          item.warehouseCount = 0;
          item.storeCount = 0;
        }
      });
      return (0, _util.axios)({
        // url: `/app/cart/preview`,
        url: '/app/ipos/cart/preview',
        method: 'POST',
        json: ids
      });
    }
  }, {
    key: 'resetDefault',
    value: function resetDefault(data) {
      !data.packs && (data.packs = []);
      !data.labels && (data.labels = []);
      !data.giftPacks && (data.giftPacks = []);
      !data.addiblePacks && (data.addiblePacks = []);
      !data.giftPacksPool && (data.giftPacksPool = []);
      !data.giftCampaigns && (data.giftCampaigns = []);
      var allPackWarehouseCount = data.packs.reduce(function (ac, current) {
        return ac + (current.warehouseCount || 0);
      }, 0);
      var _allFromStore = false;
      if (allPackWarehouseCount) {
        _allFromStore = false;
      } else {
        _allFromStore = true;
      }
      data.packs.forEach(function (p) {
        p.giftCampaigns.forEach(function (gp) {
          gp._allFromStore = _allFromStore;
        });
      });

      data.giftCampaigns.forEach(function (gp) {
        gp._allFromStore = _allFromStore;
      });
    }
  }, {
    key: 'checkPack',
    value: function checkPack(p) {
      var allPacks = this.data.packs.concat([p]);
      // let hasNormalPack = allPacks.some((pack) => {
      //   return !pack.spv.presell
      // })
      // let hasPresellPack = allPacks.some((pack) => {
      //   return pack.spv.presell
      // })
      // if (hasPresellPack && hasNormalPack) {
      //   emit('error', {
      //     message: '预售商品与普通商品不能同时加入购物车！'
      //   })
      //   return false
      // }

      var pass = !this.packs.some(function (pack) {
        if (pack.data.spv.id === p.spv.id) {
          if (pack.data.achieveMax) {
            (0, _util.emit)('error', {
              message: '超过最大数量！'
            });
            return true;
          }
          return false;
        }
      });
      return pass;
    }
  }, {
    key: 'addPack',
    value: function addPack(p) {
      console.log('addPackIpos');
      if (!this.checkPack(p)) {
        return;
      }
      var pack = this.setPackModel(p);
      // pack.select()
      this.data.packs.unshift(p);
      this.packs.unshift(pack);
      this.data.disableCheck = false;
      // this.refreshAllPreview(pack)
      return this;
    }
  }, {
    key: 'stockRefreshPreview',
    value: function stockRefreshPreview(packGuid) {
      var pack = this.packs.find(function (p) {
        return p.data.g_uid == packGuid;
      });
      this.refreshAllPreview(false, pack);
    }
  }, {
    key: 'setAddibleModel',
    value: function setAddibleModel() {
      var _this2 = this;

      var AddibleMap = {
        'ipos': _addible2.default
      };
      var Addible = AddibleMap['ipos'];
      this.addibles = [];
      this.data.addiblePacks.forEach(function (a) {
        var addible = (0, _util.create)(Addible, a);
        addible.on('complete', function () {
          _this2.refreshPreview(false);
        });
        _this2.addibles.push(addible);
      });
    }
  }, {
    key: 'setCampaignsModel',
    value: function setCampaignsModel() {
      var _this3 = this;

      this.campaignPacks = [];
      this.data.giftCampaigns.forEach(function (gift) {
        var giftCampaign = (0, _util.create)(_campaign2.default, gift);
        _this3.campaignPacks.push(giftCampaign);
      });
    }
  }, {
    key: 'addExistPack',
    value: function addExistPack(p) {
      console.log('addPackIpos');
      if (!this.checkPack(p)) {
        return;
      }
      var alreadyExistPackData = this.data.packs.filter(function (packData) {
        return packData.spv.id === p.spv.id;
      })[0];
      var alreadyExistPack = this.packs.filter(function (pack) {
        return pack.data.spv.id === p.spv.id;
      })[0];
      if (alreadyExistPack) {
        this.data.disableCheck = false;
        (0, _util.toFirst)(this.packs, alreadyExistPack);
        (0, _util.toFirst)(this.data.packs, alreadyExistPackData);
        alreadyExistPack.setCount(++alreadyExistPack.data.count, 'add');
        return;
      }
    }

    // refresh Group and Pack preview

  }, {
    key: 'refreshAllPreview',
    value: function refreshAllPreview(notRefreshAddible, pack) {
      var _this4 = this;

      console.log('refreshAllPreview');
      return this.refreshAllPreviewNoEmit(notRefreshAddible, pack).then(function (data) {
        _this4.emitPreview(data);
        return data;
      });
    }
  }, {
    key: 'refreshAllPreviewNoEmit',
    value: function refreshAllPreviewNoEmit(notRefreshAddible, originPack) {
      var _this5 = this;

      return this.preview(notRefreshAddible).then(function (data) {
        if (!data) {
          return null;
        }
        // refresh all pack's spv、giftPacks、labels、isJit
        _this5.packs.forEach(function (pack) {
          var newPackData = data.packs.filter(function (pd) {
            return pack.data.spv.id === pd.spv.id;
          })[0];
          newPackData && newPackData.spv && (pack.data.spv = newPackData.spv);
          pack.data.customizable = newPackData.customizable;
          pack.data.labels = newPackData && newPackData.labels || [];
          pack.data.giftPacks = newPackData && newPackData.giftPacks || [];
          pack.data.spv = newPackData && newPackData.spv || {};
          pack.data.giftCampaigns = newPackData.giftCampaigns;
          pack.data.isJit = newPackData.isJit;
          pack.setAchieveMax();
          pack.setLabelModel();
          pack.setGiftCampaignsModel();
        });

        // refresh origin pack's storeCount & warehouseCount
        if (originPack) {
          data.packs.some(function (p) {
            if (p.spv.id == originPack.data.spv.id) {
              originPack.data.storeCount = p.storeCount;
              originPack.data.warehouseCount = p.warehouseCount;
              return true;
            }
          });
        } else {
          // refresh all pack's storeCount & warehouseCount
          _this5.packs.forEach(function (pack) {
            var newPackData = data.packs.filter(function (pd) {
              return pack.data.spv.id === pd.spv.id;
            })[0];
            pack.data.storeCount = newPackData.storeCount;
            pack.data.warehouseCount = newPackData.warehouseCount;
          });
        }

        _this5.checkAllFromStore();

        return data;
      }).catch(function () {
        return _promise2.default.reject();
      });
    }
  }, {
    key: 'checkAllFromStore',
    value: function checkAllFromStore() {
      // if pack all from store, giftpack all from store
      this.data.packs && this.data.packs.forEach(function (p) {
        p.giftPacks && p.giftPacks.forEach(function (gp) {
          if (gp.owned) {
            if (p.storeCount && p.warehouseCount == 0) {
              gp.storeCount = gp.storeCount + gp.warehouseCount;
              gp.warehouseCount = 0;
              gp._allFromStore = true;
            } else {
              gp._allFromStore = false;
            }
          }
        });
      });

      // all pack from store, then all group's giftPacks and addiblepacks from store
      var allPackWarehouseCount = this.data.packs.reduce(function (ac, current) {
        return ac + (current.warehouseCount || 0);
      }, 0);

      this.data.giftPacks && this.data.giftPacks.forEach(function (gp) {
        if (gp.owned) {
          if (allPackWarehouseCount) {
            gp._allFromStore = false;
          } else {
            gp.storeCount = gp.storeCount + gp.warehouseCount;
            gp.warehouseCount = 0;
            gp._allFromStore = true;
          }
        }
      });

      this.data.addiblePacks && this.data.addiblePacks.forEach(function (gp) {
        if (gp.owned) {
          if (allPackWarehouseCount) {
            gp._allFromStore = false;
          } else {
            gp.storeCount = gp.storeCount + gp.warehouseCount;
            gp.warehouseCount = 0;
            gp._allFromStore = true;
          }
        }
      });
      // this.giftCampaigns.length > 0 && this.giftCampaigns.forEach((gp) => {
      //   // gp.setInWarehousePack(s)
      //   if(allPackWarehouseCount){
      //     gp.data._allFromStore = false
      //   } else {
      //     gp.data._allFromStore = true
      //   }
      // })

      // this.data.packs && this.data.packs.forEach((p) => {
      //   p.giftCampaigns && p.giftCampaigns.forEach((gp) => {
      //     if(allPackWarehouseCount){
      //       gp._allFromStore = false
      //     } else {
      //       gp._allFromStore = true
      //     }
      //   }) 
      // })
    }
  }, {
    key: 'emitPreview',
    value: function emitPreview(data) {
      /* after refresh all packs's and groups's preview, emit */
      this.emit('refresh-preview', data);
    }
  }, {
    key: 'refreshPreview',
    value: function refreshPreview(notRefreshAddible) {
      return this.refreshAllPreview(notRefreshAddible);
    }
  }, {
    key: 'getPreviewPacks',
    value: function getPreviewPacks() {
      // preview packs: packs/addible/
      var previewPacks = [];
      this.data.packs.forEach(function (pack) {
        if (pack.p_checked || pack.benefit && pack.benefit.id) {
          previewPacks.push(pack);
        }
      });
      this.data.addiblePacks && this.data.addiblePacks.forEach(function (a) {
        a.owned && previewPacks.push(a);
      });
      // this.data.giftPacks && this.data.giftPacks.forEach((g) => {
      //   g.owned && previewPacks.push(g)
      // })
      return previewPacks;
    }
  }, {
    key: 'preview',
    value: function preview(notRefreshAddible) {
      var _this6 = this;

      var atom = this.previewAtom = {};
      var previewPacks = this.getPreviewPacks();
      var checkedPacks = this.getCheckedPacks();
      if (!checkedPacks.length) {
        // this.previewAtom = {} // make preview ajax response invalid
        this.emptyPreview();
        this.data.allChecked = false;
        console.log(this.data.title, 'empty preview');
        this.emit('refresh-preview', null);
        return _promise2.default.resolve(null);
      }
      (0, _util.emit)('show-loading', 'preview');
      return this.getPreview(previewPacks).then(function (_ref) {
        var data = _ref.data;

        if (atom !== _this6.previewAtom || _this6.data.editMode) {
          return _promise2.default.resolve(null);
        }
        (0, _util.emit)('hide-loading', 'preview');
        _this6.resetDefault(data);
        // refresh group labels and giftPacks
        if (!notRefreshAddible) {
          _this6.data.addiblePacks = data.addiblePacks;
          _this6.setAddibleModel();
        }
        _this6.data.labels = data.labels;
        _this6.data.giftPacks = data.giftPacks;
        _this6.data.giftPacksPool = data.giftPacksPool;
        _this6.data.giftCampaigns = data.giftCampaigns;
        _this6.setLabelModel();
        _this6.setCampaignsModel();
        _this6.setInvalidPacks(data);
        /* after refresh all packs's and groups's preview, emit */
        // this.emit('refresh-preview', data)
        return data;
      }).catch(function (_ref2) {
        var message = _ref2.message;

        (0, _util.emit)('hide-loading', 'preview');
        (0, _util.emit)('error', {
          message: message,
          type: 'preview'
        });
        return _promise2.default.reject();
      });
    }
  }, {
    key: 'emptyPreview',
    value: function emptyPreview() {
      this.packs.forEach(function (pack) {
        pack.emptyPreview();
      });
      this.data.addiblePacks = [];
      this.data.labels = [];
      this.data.giftPacks = [];
      this.data.giftCampaigns = [];
      this.setLabelModel();
      this.setCampaignsModel();
      this.setAddibleModel();
      this.resetInvalidPacks();
      // this.setGiftCampaignsModel()
    }
  }]);
  return Group;
}(_group2.default);

exports.default = Group;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@beastshop/cart/lib/model/ipos/group.js
// module id = 1162
// module chunks = 0